export enum CustomFieldTypeEnum {
    TEXT ='text',
    PEOPLE = 'people',
    SINGLE_SELECT = 'single_select'
}

export enum FetchKnowledgeTabsEnum {
    DOCUMENTS = 'documents',
    CONVERSATIONS = 'conversations'
}
